import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ContextLanguage } from "../../../context/Context.Language";
// import FunctionRepleteFont from "../../../utils/FunctionRepleteFont";
import {
  TEXT_AN_ORDER_NOW,
  TEXT_BKK_AND_PTY,
  TEXT_CONTACT_US,
  TEXT_CREATE,
  TEXT_FAQ,
  TEXT_GO_TO_FAQ,
  TEXT_HAVE_MORE_QUESTION,
  TEXT_OR,
  TEXT_OUR_ANSWER,
  TEXT_OUR_ANSWER_2,
  TEXT_OUR_ANSWER_MB,
} from "../../../utils/useConstants";
import { useIsMobile } from "../../../utils/useIsMobile";
import {
  STYLE_GRID_HOME_FAQ,
  STYLE_HEADING_2,
  STYLE_IMG_SECTION,
  STYLE_LINK_BLUE,
  STYLE_SIZE_FAQ_HOME,
  STYLE_TITLE_HOME_FAQ,
  STYLE_UNDERLINE_BLUE_24_16,
  STYLE_WIDTH_CONTENT,
} from "../../../utils/useStyle";

import { FirstOrder } from "../../faq/render/Faq.List";

export const ENG = ({ language }) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  return (
    <div>
      {isMobile ? (
        <div
          className={`text-center text-laundry-gray-100 mb-6 md:mb-10 text-sm xl:text-base`}
        >
          {TEXT_OUR_ANSWER[language]}
          <span>{TEXT_HAVE_MORE_QUESTION[language]}</span>
          <span>
            <span
              onClick={() => {
                navigate("/ContactUs");
              }}
              className={STYLE_LINK_BLUE}
            >
              {TEXT_CONTACT_US[language]}
            </span>
            <span className="">{TEXT_OR[language]}</span>
            <span
              className={`${STYLE_LINK_BLUE} mx-1`}
              onClick={() => {
                navigate("/OurServices");
              }}
            >
              {TEXT_CREATE[language]}
            </span>
            <span>{TEXT_AN_ORDER_NOW[language]}</span>
          </span>
        </div>
      ) : (
        <div
          className={`${`text-center text-laundry-gray-100 mb-6 md:mb-10 text-sm xl:text-base`} `}
        >
          {TEXT_OUR_ANSWER[language]}
          <span>
            {TEXT_HAVE_MORE_QUESTION[language]}
            <span
              onClick={() => {
                navigate("/ContactUs");
              }}
              className={STYLE_LINK_BLUE}
            >
              {TEXT_CONTACT_US[language]}
            </span>
            <span className="">{TEXT_OR[language]}</span>
            <span
              className={`${STYLE_LINK_BLUE} mx-1`}
              onClick={() => {
                navigate("/OurServices");
              }}
            >
              {TEXT_CREATE[language]}
            </span>
            <span>{TEXT_AN_ORDER_NOW[language]}</span>
          </span>
        </div>
      )}
    </div>
  );
};
export const TH = ({ language }) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  return (
    <div>
      {isMobile ? (
        <div
          className={`text-center text-laundry-gray-100 mb-6 md:mb-10 text-sm-th xl:text-base-th`}
        >
          {TEXT_OUR_ANSWER_MB[language]}
          <div>
            {TEXT_BKK_AND_PTY[language]}
            <span> {TEXT_HAVE_MORE_QUESTION[language]}</span>
          </div>

          <div>
            <span
              onClick={() => {
                navigate("/ContactUs");
              }}
              className={STYLE_LINK_BLUE}
            >
              {TEXT_CONTACT_US[language]}
            </span>
            <span className="">{TEXT_OR[language]}</span>
            <span
              className={`${STYLE_LINK_BLUE} mx-1`}
              onClick={() => {
                navigate("/OurServices");
              }}
            >
              {TEXT_CREATE[language]}
            </span>
            <span>{TEXT_AN_ORDER_NOW[language]}</span>
          </div>
        </div>
      ) : (
        <div
          className={`text-center text-laundry-gray-100 mb-6 md:mb-10 text-sm-th xl:text-base-th `}
        >
          {TEXT_OUR_ANSWER[language]}
          <div>
            {TEXT_OUR_ANSWER_2[language]} {TEXT_HAVE_MORE_QUESTION[language]}
          </div>
          <div>
            <span
              onClick={() => {
                navigate("/ContactUs");
              }}
              className={STYLE_LINK_BLUE}
            >
              {TEXT_CONTACT_US[language]}
            </span>
            <span className="">{TEXT_OR[language]}</span>
            <span
              className={`${STYLE_LINK_BLUE} mx-1`}
              onClick={() => {
                navigate("/OurServices");
              }}
            >
              {TEXT_CREATE[language]}
            </span>
            <span>{TEXT_AN_ORDER_NOW[language]}</span>
          </div>
        </div>
      )}
    </div>
  );
};

const FaqSection = () => {
  const navigate = useNavigate();
  const { language } = React.useContext(ContextLanguage);
  const [open, setOpen] = React.useState(false);

  // React.useEffect(() => {
  //   if (open) {
  //     FunctionRepleteFont({ language });
  //   }
  // }, [open]);

  return (
    <div className={STYLE_WIDTH_CONTENT}>
      <div className={`${STYLE_HEADING_2(language)} text-center`}>
        {TEXT_FAQ[language]}
      </div>
      <div className={STYLE_UNDERLINE_BLUE_24_16}></div>
      {language === "EN" ? (
        <ENG language={language} />
      ) : (
        <TH language={language} />
      )}
      <FirstOrder
        setOpen={setOpen}
        open={open}
        classNameFont={STYLE_SIZE_FAQ_HOME(language)}
        classNameTitle={`${STYLE_TITLE_HOME_FAQ(language)}`}
      />
      <div className=" mx-auto w-fit">
        <div
          onClick={() => navigate("/FAQ")}
          className={` ${
            language === "TH"
              ? " text-sm-th md:text-base-th "
              : " text-sm md:text-base "
          } ${STYLE_LINK_BLUE} text-center cursor-pointer  mt-4 md:mt-6 `}
        >
          {TEXT_GO_TO_FAQ[language]}
        </div>
      </div>
    </div>
  );
};

const HomeFaq = () => {
  const isMobile = useIsMobile();
  const location = useLocation();

  return (
    <div>
      {" "}
      <div className={`${STYLE_GRID_HOME_FAQ}  `}>
        <FaqSection />
        {isMobile ? (
          ""
        ) : (
          <img
            src="/images/faq.png"
            className={`${STYLE_IMG_SECTION} ml-auto mt-[90px]`}
          />
        )}
      </div>
    </div>
  );
};

export default HomeFaq;
